import ReactGA from "react-ga4";

const GA_TRACKING_ID = "G-YJQ6H96DWV";

export const initGA = () => {
  ReactGA.initialize(GA_TRACKING_ID);
};

export const logPageView = (pathname) => {
  ReactGA.send({ hitType: "pageview", page: pathname });
};
